import { render, staticRenderFns } from "./EquipTypeComponent.vue?vue&type=template&id=020b29fe"
import script from "./EquipTypeComponent.vue?vue&type=script&lang=js"
export * from "./EquipTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports